import React, { useEffect, useRef } from "react"

import type { ButtonVariantType } from "packages/ui-shared/components/Button/Button"
import { Button } from "packages/ui-shared/components/Button/Button"

import type { ProductCardDataType } from "./types"

type Props = {
  product: Pick<ProductCardDataType, "buttonText" | "isPrimaryButtonDisabled">
  onClick?: () => void
  variant?: ButtonVariantType
}

export const ProductCardButton: React.FC<Props> = ({
  product,
  onClick,
  variant = "primary",
}) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null)
  useEffect(() => {
    if (buttonRef && buttonRef.current) {
      buttonRef.current.dataset.testRenderState = "complete"
    }
  }, [product.buttonText])

  return (
    <Button
      buttonRef={buttonRef}
      variant={variant}
      disabled={product.isPrimaryButtonDisabled}
      handleClick={(event) => {
        event?.preventDefault()
        event?.stopPropagation()
        onClick?.()
      }}
      width="full"
    >
      {product.buttonText}
    </Button>
  )
}
